import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'
import AjaxApi from '../lib/AjaxApi'
import Countdown from 'countdown-js'

export default class CountdownTimer extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._elem = elem
    this._options = {...{
      epoch: 0,
      seperator: ':'
    }, ...this._options}
    this._timer = null
    this._timerElems = this._elem.querySelectorAll('[data-time]')
  }

  async  mount () {
    let CountdownDate

    if (this._options.epoch) {
      CountdownDate = new Date(this._options.epoch * 1000)
    }

    if (this._options.time) {
      let todayDate = new Date()
      let month = todayDate.getUTCMonth() + 1
      let day = todayDate.getUTCDate()
      let year = todayDate.getUTCFullYear()
      let todayYYMMDD = year + "/" + month + "/" + day

      CountdownDate = new Date(todayYYMMDD + ' ' + this._options.time + ':00')
      
      if (this._options.time_zone) {
        CountdownDate = this._changeTimezone(CountdownDate, this._options.time_zone)
      }
    }

    this._timer = Countdown.timer(CountdownDate, (timeLeft) => {
      this._updateTimeElems(timeLeft)
    }, () => {
      this._updateTimeElems({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }, false)
    })
  }

  _changeTimezone(date, timezone) {
    let invdate = new Date(date.toLocaleString('en-US', {
      timeZone: timezone
    }))
    let diff = date.getTime() - invdate.getTime()
    return new Date(date.getTime() + diff)
  }

  _updateTimeElems (timeLeft, reachedZero = true) {
    for (let [index, timeElem] of this._timerElems.entries()) {
      let time = timeLeft[timeElem.dataset.time]
      if (time === 0 && reachedZero) {
        timeElem.classList.add('hide')
      } else {
        reachedZero = false
        timeElem.textContent = Helpers.pad(time, 2)

        if (!this._options.numbersOnly) {
          if (timeElem.dataset.time === 'days') {
            timeElem.textContent += 'd'
          }

          if (timeElem.dataset.time === 'hours') {
            timeElem.textContent += 'h'
          }

          if (timeElem.dataset.time === 'minutes') {
            timeElem.textContent += 'm'
          }

          if (timeElem.dataset.time === 'seconds') {
            timeElem.textContent += 's'
          }
        }

        if ((index + 1) !== this._timerElems.length) {
          timeElem.textContent += this._options.seperator
        }

        if (timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0) {
          this._elem.classList.add('hide')

          if (this._options.hideParentElement) {
            for (let el of document.querySelectorAll(this._options.hideParentElement)) {
              el.classList.remove()
            }

            if (document.querySelector(this._options.hideParentElement).classList.contains('keen-slider__slide')) {
              let slider = this._elem.closest('[data-keen-slider]')
              let comp = this._theme.getComponentByElem(slider)

              if (comp) {
                comp.component._slider.update()
              }
            }
          }
        }
      }
    }
  }
}